import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17"
		height="18"
		fill="none"
		viewBox="0 0 17 18"
		{...props}
	>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.063"
			d="M9.968 3.156c.403 0 .77.228.95.588l.476.95c.18.36.548.587.95.587h1.469c.88 0 1.593.714 1.593 1.594v6.375c0 .88-.713 1.594-1.594 1.594H3.188c-.88 0-1.594-.714-1.594-1.594V6.875c0-.88.713-1.594 1.594-1.594h1.468c.402 0 .77-.227.95-.587l.475-.95c.18-.36.548-.588.95-.588z"
			clipRule="evenodd"
		/>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.063"
			d="M10.36 9.797a2.125 2.125 0 1 0-4.25 0 2.125 2.125 0 0 0 4.25 0"
			clipRule="evenodd"
		/>
		<path
			fill="var(--svg-color, currentColor)"
			fillRule="evenodd"
			d="M13.813 7.672a.797.797 0 1 0-1.594 0 .797.797 0 0 0 1.594 0"
			clipRule="evenodd"
		/>
	</svg>
);
export { SvgComponent as CameraIcon };
